import { render, staticRenderFns } from "./ProductListAction.vue?vue&type=template&id=4adf1878"
import script from "./ProductListAction.vue?vue&type=script&lang=js"
export * from "./ProductListAction.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports